<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <div class="table-agile-info">
          <jm-crumbs/>
          <div class="common-new-title mode2"><span>时间轴配置列表</span></div>
          <el-table
            :data="tableData"
            style="width: 100%">
            <el-table-column
              prop="id"
              label="序号"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              label="名称"
            >
            </el-table-column>
            <el-table-column
              label="操作"
            >
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="text" size="small">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="common-new-title mode2"><span>规划书内容配置</span></div>
          <div class="basic-title"><em>警句编辑</em></div>
          <div class="this-content-wrap">
            <div class="this-content1-area" v-for="(item, idx) in plcList" :key="idx">
              <span>{{ idx + 1 }}、</span>
              <el-input v-model="plcList[idx].comment" />
              <div class="btn-area">
                <el-button type="primary" v-if="plcList.length > 1" @click="content1Delete(idx)">-</el-button>
                <el-button type="primary" v-if="plcList.length === idx + 1" @click="content1Add">+</el-button>
              </div>
            </div>
          </div>
          <div class="basic-title"><em>留学费用编辑</em></div>
          <div class="this-content-wrap">
            <div class="this-content2-area">
              <!--              <h3>赴日前费用问题</h3>-->
              <quill-editor
                v-model="priceList.priceDetail"
                :options="editorOption"/>
              <!--              <h3>费用明细上传</h3>-->
              <!--              <el-upload-->
              <!--                class="file-uploader"-->
              <!--                action=""-->
              <!--                :show-file-list="false"-->
              <!--                :on-error="uploadError"-->
              <!--                :on-success="uploadSuccess"-->
              <!--                :before-upload="beforeUpload">-->
              <!--                <img v-if="priceList.priceImg" :src="priceList.priceImg" class="avatar">-->
              <!--                <i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
              <!--              </el-upload>-->
              <div class="basic-title" style="margin-top: 50px"><em>打工</em></div>
              <quill-editor
                v-model="priceList.priceJob"
                :options="editorOption"/>
            </div>
          </div>
          <div class="basic-title"><em>祝福信编辑</em></div>
          <div class="this-content-wrap">
            <div class="this-content1-area mode2" v-for="(item, idx) in mailList" :key="idx">
              <span>{{ idx + 1 }}、</span>
              <el-input
                type="textarea"
                :rows="6"
                placeholder="请输入"
                v-model="mailList[idx].comment">
              </el-input>
              <div class="btn-area">
                <el-button type="primary" v-if="mailList.length > 1" @click="content3Delete(idx)">-</el-button>
                <el-button type="primary" v-if="mailList.length === idx + 1" @click="content3Add">+</el-button>
              </div>
            </div>
          </div>
          <div class="this-save-area">
            <el-button type="primary" @click="pageSave">保存</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import crumbs from '@/components/tool/crumbs';
import tableList from '@/components/data/tableList.vue';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';

export default {
  data() {
    return {
      plcList: [],
      mailList: [],
      priceList: {
        priceDetail: null,
        priceJob: ''
      },
      editorOption: {
        placeholder: '请输入内容',
        modules: {
          toolbar: [
            ['bold', 'underline', 'strike'],
            [{ align: [] }],
            [{ size: ['small', false, 'large', 'huge'] }],
            [{ color: [] }, { background: [] }],
            ['image'],
            ['clean'],
          ]
        }
      },
      tableData: [{
        id: 1,
        name: '语学院',
        type: 1
      }, {
        id: 2,
        name: '学部',
        type: 2
      }, {
        id: 3,
        name: '大学院文科',
        type: 3
      }, {
        id: 4,
        name: '大学院理科',
        type: 5
      }, {
        id: 5,
        name: '艺术',
        type: 4
      }
      ]
    };
  },
  methods: {
    // 保存
    pageSave() {
      this.$http._post({
        url: '/index/Study_planning/setPlanConfigration',
        data: { plcList: this.plcList, mailList: this.mailList, priceList: this.priceList }
      }).then((res) => {
        if (res.data === 1) {
          this.$message.success('保存成功');
        } else {
          this.$message.error('保存失败');
        }
      });
    },
    handleClick(data) {
      this.$router.push({ name: 'timePlanEdit', query: { tid: data.type, tname: data.name } });
    },
    // 祝福信删除
    content3Delete(idx) {
      this.mailList.splice(idx, 1);
    },
    // 祝福信添加
    content3Add() {
      this.mailList.push({ id: '', comment: '' });
    },
    // 警句删除
    content1Delete(idx) {
      this.plcList.splice(idx, 1);
    },
    // 警句添加
    content1Add() {
      this.plcList.push({ id: '', comment: '' });
    },
    // 上传成功
    uploadSuccess(res, file) {
      console.log(res);
      this.priceList.priceImg = URL.createObjectURL(file.raw);
    },
    // 上传失败
    uploadError(err) {
      console.log(err);
      this.$message.error('上传失败，请检查网络');
    },
    // 设置上传参数
    beforeUpload(file) {
      console.log(file);
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG或PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    getBasicInfo() {
      this.$http._post({
        url: '/index/Study_planning/getPlanConfigration',
        data: {},
      }).then((response) => {
        this.plcList = response.data.aphorism;
        this.mailList = response.data.blessingMessage;
        this.priceList.priceDetail = response.data.overeasStudyExpense;
        this.priceList.priceJob = response.data.overeasJobExpense;
      });
    }
  },
  mounted() {
    this.getBasicInfo();
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-tableList': tableList,
    quillEditor
  },
};
</script>

<style scoped>
  .quill-editor {
    height: 400px;
    width: 50%;
    margin-top: 20px;
  }
  .this-content-wrap{
    padding: 0 8px 25px;
  }
  .this-content1-area{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 15px;
  }
  .this-content1-area:first-of-type{
    margin-top: 20px;
  }
  .this-content1-area:last-of-type{
    margin-bottom: 0;
  }
  .this-content1-area .el-input{
    width: 50%;
  }
  .this-content1-area .btn-area{
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .this-content1-area .btn-area .el-button{
    width: 20px;
    height: 20px;
    line-height: 20px;
    padding: 0;
    margin: 0 0 0 10px;
  }
  .this-content2-area{
    padding-bottom: 10px;
  }
  .this-content2-area h3{
    font-size: 14px;
    font-weight: normal;
    color: #3368fa;
    padding-top: 15px;
    padding-bottom: 10px;
  }
  .this-content2-area .el-textarea{
    width: 50%;
  }
  .basic-title{
    margin-bottom: 0;
  }
  .file-uploader{
    border: 1px dashed #3368fa;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    display: inline-block;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .this-content1-area.mode2{
    align-items: flex-start;
  }
  .this-content1-area.mode2 .el-textarea{
    width: 50%;
  }
  .this-content1-area.mode2 .btn-area{
    padding-top: 100px;
  }
  .this-save-area{
    padding: 0 0 20px 10px;
  }
</style>
